import { render, staticRenderFns } from "./DocumentoNav.vue?vue&type=template&id=97458834&"
import script from "./DocumentoNav.vue?vue&type=script&lang=js&"
export * from "./DocumentoNav.vue?vue&type=script&lang=js&"
import style0 from "./DocumentoNav.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports